<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <drivers-periods-unavailable-edit-form
        @on-submit="onDriverFieldEditSubmit"
      ></drivers-periods-unavailable-edit-form>
    </div>
  </div>
</template>
<script>
import DriversPeriodsUnavailableEditForm from "@/pages/Dashboard/Drivers/DriversPeriodsUnavailableEditForm";

export default {
  components: {
    DriversPeriodsUnavailableEditForm
  },
  data() {
    return {
      holidayEditModel: {}
    };
  },
  methods: {
    onDriverFieldEditSubmit(model) {
      this.holidayEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'holidayss/' + this.holidayEditModel.id, Object.assign(this.holidayEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
